import { ExtraParameterModel } from './ExtraParameterModel';

export interface ExtraParametersBatchModel {
    extraParameters: ExtraParameterModel[],
    categoriesId: number[]
}

export const extraParametersBatchModelInitial: ExtraParametersBatchModel = {
    extraParameters: [],
    categoriesId: []
};